import { LockKeyhole, RefreshCw } from "lucide-react";

export function InstitutionalAccessPage({
  error = null,
  label = "Esta sección",
  loading = false,
  onRetry = null,
}) {
  if (loading) {
    return (
      <main className="institutional-access-page" role="status">
        <div className="institutional-access-card">
          <span className="institutional-access-icon" aria-hidden="true">
            <RefreshCw className="institutional-access-spinner" size={22} />
          </span>
          <h1>Verificando accesos…</h1>
          <p>Estamos preparando las herramientas de este espacio.</p>
        </div>
      </main>
    );
  }

  const unavailable = Boolean(error);
  return (
    <main className="institutional-access-page" role="alert">
      <div className="institutional-access-card">
        <span className="institutional-access-icon" aria-hidden="true">
          {unavailable
            ? <RefreshCw size={22} />
            : <LockKeyhole size={22} />}
        </span>
        <span className="institutional-access-eyebrow">
          {unavailable ? "ACCESO NO VERIFICADO" : "ACCESO DE LA ORGANIZACIÓN"}
        </span>
        <h1>
          {unavailable
            ? "No pudimos verificar tus accesos."
            : `${label} no está habilitada en este espacio.`}
        </h1>
        <p>
          {unavailable
            ? error.message
            : "La organización administra qué aplicaciones y herramientas se muestran dentro de su espacio. Podés cambiar a tu espacio personal o consultar con su administrador."}
        </p>
        {unavailable && onRetry && (
          <button type="button" onClick={onRetry}>
            Reintentar
          </button>
        )}
      </div>
    </main>
  );
}
